// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/NotoSansTC-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/NotoSansTC-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/NotoSansTC-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/NotoSansTC-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/NotoSansTC-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Exo-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Exo-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Orbitron-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/fonts.css */

@font-face {
    font-family: 'Noto Sans TC Light';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    /* 如果有其他字体格式，可以在这里添加，例如： */
    /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */
}

@font-face {
  font-family: 'Noto Sans TC Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  /* 如果有其他字体格式，可以在这里添加，例如： */
  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */
}

@font-face {
  font-family: 'Noto Sans TC Thin';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  /* 如果有其他字体格式，可以在这里添加，例如： */
  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */
}

@font-face {
  font-family: 'Noto Sans TC Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  /* 如果有其他字体格式，可以在这里添加，例如： */
  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */
}

@font-face {
  font-family: 'Noto Sans TC Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  /* 如果有其他字体格式，可以在这里添加，例如： */
  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */
}
@font-face {
  font-family: 'Exo Italic VariableFont wght';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  /* 如果有其他字体格式，可以在这里添加，例如： */
  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */
}

@font-face {
  font-family: 'Exo VariableFont wght';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  /* 如果有其他字体格式，可以在这里添加，例如： */
  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */
}

@font-face {
  font-family: 'Orbitron VariableFont wght';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  /* 如果有其他字体格式，可以在这里添加，例如： */
  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */
}

  /* 定义其他全局样式，例如 body、h1、p 等 */
body {
    font-family: 'Noto Sans TC Light', sans-serif;
    /* 其他全局样式 */
}
  
/* 可以定义其他样式，或者在其他CSS文件中定义 */`, "",{"version":3,"sources":["webpack://./src/fonts.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;IACI,iCAAiC;IACjC,+DAA2D;IAC3D,0BAA0B;IAC1B,+DAA+D;AACnE;;AAEA;EACE,mCAAmC;EACnC,+DAA6D;EAC7D,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,gCAAgC;EAChC,+DAA0D;EAC1D,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,kCAAkC;EAClC,+DAA4D;EAC5D,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,gCAAgC;EAChC,+DAA0D;EAC1D,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,2CAA2C;EAC3C,+DAAuE;EACvE,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,oCAAoC;EACpC,+DAAgE;EAChE,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,yCAAyC;EACzC,+DAAqE;EACrE,0BAA0B;EAC1B,+DAA+D;AACjE;;EAEE,4BAA4B;AAC9B;IACI,6CAA6C;IAC7C,WAAW;AACf;;AAEA,2BAA2B","sourcesContent":["/* src/fonts.css */\n\n@font-face {\n    font-family: 'Noto Sans TC Light';\n    src: url('./fonts/NotoSansTC-Light.otf') format('truetype');\n    /* 如果有其他字体格式，可以在这里添加，例如： */\n    /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */\n}\n\n@font-face {\n  font-family: 'Noto Sans TC Regular';\n  src: url('./fonts/NotoSansTC-Regular.otf') format('truetype');\n  /* 如果有其他字体格式，可以在这里添加，例如： */\n  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */\n}\n\n@font-face {\n  font-family: 'Noto Sans TC Thin';\n  src: url('./fonts/NotoSansTC-Thin.otf') format('truetype');\n  /* 如果有其他字体格式，可以在这里添加，例如： */\n  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */\n}\n\n@font-face {\n  font-family: 'Noto Sans TC Medium';\n  src: url('./fonts/NotoSansTC-Medium.otf') format('truetype');\n  /* 如果有其他字体格式，可以在这里添加，例如： */\n  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */\n}\n\n@font-face {\n  font-family: 'Noto Sans TC Bold';\n  src: url('./fonts/NotoSansTC-Bold.otf') format('truetype');\n  /* 如果有其他字体格式，可以在这里添加，例如： */\n  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */\n}\n@font-face {\n  font-family: 'Exo Italic VariableFont wght';\n  src: url('./fonts/Exo-Italic-VariableFont_wght.ttf') format('truetype');\n  /* 如果有其他字体格式，可以在这里添加，例如： */\n  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */\n}\n\n@font-face {\n  font-family: 'Exo VariableFont wght';\n  src: url('./fonts/Exo-VariableFont_wght.ttf') format('truetype');\n  /* 如果有其他字体格式，可以在这里添加，例如： */\n  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */\n}\n\n@font-face {\n  font-family: 'Orbitron VariableFont wght';\n  src: url('./fonts/Orbitron-VariableFont_wght.ttf') format('truetype');\n  /* 如果有其他字体格式，可以在这里添加，例如： */\n  /* src: url('./fonts/MicrosoftJhengHei.woff') format('woff'); */\n}\n\n  /* 定义其他全局样式，例如 body、h1、p 等 */\nbody {\n    font-family: 'Noto Sans TC Light', sans-serif;\n    /* 其他全局样式 */\n}\n  \n/* 可以定义其他样式，或者在其他CSS文件中定义 */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
